module.exports = require("./media/js/jquery.dataTables.js");
require("./media/css/jquery.dataTables.css");
require("./media/images/sort_asc.png");
require("./media/images/sort_asc_disabled.png");
require("./media/images/sort_both.png");
require("./media/images/sort_desc.png");
require("./media/images/sort_desc_disabled.png");


//////////////////
// WEBPACK FOOTER
// datatables (bower component)
// module id = 1091
// module chunks = 1